(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legtone-signup"] && !Shopify.designMode) return;
  try {
     
// $("#mc-embedded-subscribe-form").on("submit", function (e) {
// 	e.preventDefault();
// 	$(".error_message").slideUp();
// 	$.ajax({
// 		type: "POST",
// 		url:
// 			"https://adoniaorganics.us20.list-manage.com/subscribe/post?u=583eb2abd87aea16641234995&amp;id=b07e99a4bb&amp;f_id=00db28e0f0",
// 		data: $("#mc-embedded-subscribe-form").serialize(),
// 		cache: false,
// 		dataType: "json",
// 		contentType: "application/json; charset=utf-8",
// 		error: (error) => {
// 			$(".error_message").slideDown();
// 			$(".error_list").html(error);
// 		},
// 		success: (res) => {
// 			$("#mc-embedded-subscribe-form").slideUp();
// 			$(".success_message").slideDown();
// 		}
// 	});
// });
document.getElementById("mc-embedded-subscribe-form").addEventListener("submit", function (e) {
  e.preventDefault();

  var form = this;
  var errorMessage = document.querySelector(".error_message");
  var successMessage = document.querySelector(".success_message");
  var errorList = document.querySelector(".error_list");

  if (errorMessage) errorMessage.style.display = "none";

  // Build the post-json URL from the form fields
  var params = new URLSearchParams(new FormData(form)).toString();
  var cbName = "mcCallback_" + Date.now();
  var url =
    "https://adoniaorganics.us20.list-manage.com/subscribe/post-json" +
    "?u=583eb2abd87aea16641234995&id=b07e99a4bb&f_id=00db28e0f0" +
    "&" + params +
    "&c=" + cbName;

  // Define the global callback Mailchimp will invoke
  window[cbName] = function (data) {
    if (data.result === "success") {
      form.style.display = "none";
      if (successMessage) successMessage.style.display = "block";
    } else {
      if (errorMessage) errorMessage.style.display = "block";
      if (errorList) errorList.innerHTML = data.msg || "Subscription failed.";
    }
    // cleanup
    delete window[cbName];
    if (script.parentNode) script.parentNode.removeChild(script);
  };

  // Inject the JSONP request
  var script = document.createElement("script");
  script.src = url;
  document.body.appendChild(script);
});

  } catch(e) { console.error(e); }
})();
})();
